module.exports = __webpack_public_path__ + "img/logo.08d66bc3.jpeg";